import "./Button.css";
import classnames from "classnames";

interface Props {
  children: React.ReactNode;
  fullWidth?: boolean;
  dark?: boolean;
  social?: boolean;
  Icon?: React.FC;
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
  href?: string;
  isInline?: boolean;
  outline?: boolean;
}

export default function Button({
  children,
  fullWidth = false,
  dark = false,
  social = false,
  Icon = () => null,
  href,
  isInline,
  outline,
  ...props
}: Props) {
  const className = classnames("Button", {
    fullWidth: fullWidth,
    dark: dark,
    social: social,
    isInline,
    outline,
  });

  return !!href ? (
    <a className={className} href={href} {...props}>
      <Icon />
      {children}
    </a>
  ) : (
    <button className={className} {...props}>
      <Icon />
      {children}
    </button>
  );
}
